export function CheckCircleBrokenIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='12' height='13' viewBox='0 0 12 13' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <g clipPath='url(#clip0_513_2265)'>
        <path
          d='M11 6.39286V6.85286C10.9994 7.93107 10.6503 8.9802 10.0047 9.84377C9.35908 10.7073 8.45164 11.3391 7.41768 11.6448C6.38372 11.9505 5.27863 11.9138 4.26724 11.5402C3.25584 11.1665 2.39233 10.4759 1.80548 9.57139C1.21863 8.66688 0.939896 7.59689 1.01084 6.52102C1.08178 5.44514 1.4986 4.42102 2.19914 3.6014C2.89968 2.78177 3.84639 2.21055 4.89809 1.97293C5.9498 1.73532 7.05013 1.84403 8.035 2.28286M11 2.85L6 7.855L4.5 6.355'
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_513_2265'>
          <rect width='12' height='12' fill='white' transform='translate(0 0.849998)' />
        </clipPath>
      </defs>
    </svg>
  )
}
